import { all, put, takeEvery } from "redux-saga/effects";
import { fetcher, getErrorMsg, handleError } from "lib/fetch";
import * as actions from "./actions";

const url = "faq";

function* createFaq(action) {
  try {
    const { params, token } = action.payload;
    const res = yield fetcher.post(`${url}/create`, params, token);
    yield put(actions.createFaq.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.createFaq.failure(getErrorMsg(error)));
  }
}

function* showFaq(action) {
  try {
    const { id, token } = action.payload;
    const res = yield fetcher.get(`${url}/${id}`, token);
    yield put(actions.showFaq.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.showFaq.failure(getErrorMsg(error)));
  }
}

function* updateFaq(action) {
  try {
    const { params, id, token } = action.payload;
    const res = yield fetcher.post(`${url}/update/${id}`, params, token);
    yield put(actions.updateFaq.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.updateFaq.failure(getErrorMsg(error)));
  }
}

export default function* watchFaq() {
  yield all([
    takeEvery(actions.CREATE_FAQ.REQUEST, createFaq),
    takeEvery(actions.SHOW_FAQ.REQUEST, showFaq),
    takeEvery(actions.UPDATE_FAQ.REQUEST, updateFaq),
  ]);
}
